import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/trash.svg'
import _imports_1 from '@/assets/img/photo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-83b41808")

_pushScopeId("data-v-83b41808")
const _hoisted_1 = { class: "select_file" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "uploadFileContainer" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "imageContainer mini",
      style: 'background-image: url(\'' + _ctx.publicUrl + '\')'
    }, [
      (_ctx.publicUrl)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "deleteButton primaryButton squareButton",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.removeFile()), ["stop"]))
          }, [
            _hoisted_2
          ]))
        : (_openBlock(), _createBlock("img", _hoisted_3)),
      _createVNode(_component_form_field, {
        type: "file",
        "onUpdate:modelValue": _ctx.imageChangedTemp
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onUpdate:modelValue"])
    ], 4)
  ]))
})